const SCOPES = {
  SERVICE_PROVIDER: 'serviceProvider',
  LOCATION: 'location',
};

const LOCATIONS_STEPPER_ID = 'LOCATIONS';

export { SCOPES, LOCATIONS_STEPPER_ID };
